module.exports = __webpack_public_path__ + "img/circle12.a4d06e7f.png";